import { render, staticRenderFns } from "./displayScreenIndex.vue?vue&type=template&id=126774f2&scoped=true"
import script from "./displayScreenIndex.vue?vue&type=script&lang=js"
export * from "./displayScreenIndex.vue?vue&type=script&lang=js"
import style0 from "./displayScreenIndex.vue?vue&type=style&index=0&id=126774f2&prod&scoped=true&lang=scss"
import style1 from "./displayScreenIndex.vue?vue&type=style&index=1&id=126774f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126774f2",
  null
  
)

export default component.exports